import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  repositoryCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'repositoryModel',
    'documentTypeModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Repository,
      DocumentType
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE REPOSITORY'),
        };
      }

      function sortColumns() {
        return [
          { column: 'name', title: 'NAME', type: 'text', sortOrder: 'asc' },
          {
            column: 'description',
            title: 'DESCRIPTION',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = [];
        deferred.resolve(filters);
        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();

        var url = 'folders/repositories';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Repository(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function selectDocumentTypes(repository, documentTypes) {
        repository.documentTypes.forEach(function (c) {
          var fs = documentTypes.filter(function (d) {
            return d.id === c.IdDocumentType;
          });
          fs[0].selected = true;
        });
        repository.allDocumentTypes = documentTypes;
      }

      function load(id) {
        var deferred = $q.defer();

        var repository = new Repository();
        var documentTypes = null;
        var done = false;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'documentType', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              documentTypes = [];
              data.forEach(function (d) {
                var documentType = new DocumentType(d);
                documentTypes.push(documentType);
              });

              if (id && repository.id !== 0 && !done) {
                selectDocumentTypes(repository, documentTypes);
                done = true;
                deferred.resolve(repository);
              } else if (!id && !done) {
                repository.allDocumentTypes = documentTypes;
                done = true;
                deferred.resolve(repository);
              }
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        if (id) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri + 'folders/repositories/' + id,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                repository = new Repository(data);

                if (documentTypes !== null && !done) {
                  selectDocumentTypes(repository, documentTypes);
                  done = true;
                  deferred.resolve(repository);
                }
              },
              function (err) {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              }
            );
        }

        return deferred.promise;
      }

      function save(repository) {
        var deferred = $q.defer();

        repository.documentTypesFolders = [];
        var documentTypes = repository.allDocumentTypes.filter(function (d) {
          return d.selected;
        });
        documentTypes.forEach(function (d) {
          repository.documentTypesFolders.push({
            IdFolder: repository.id,
            IdDocumentType: d.id,
          });
        });

        if (repository.id === 0) {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'folders/repositories',
              repository,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        } else {
          $http
            .put(
              webApiSettings.apiServiceBaseUri + 'folders/repositories',
              repository,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'folders/repositories/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            if (err.data.ModelState) {
              if (err.data.ModelState.RepositoryHasChildren) {
                deferred.reject({
                  title: $filter('translate')('NOT IS EMPTY'),
                  text: err.data.ModelState.RepositoryHasChildren[0],
                });
              }
            }

            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var repositoryCrudFactory = {};

          repositoryCrudFactory.folders = [];

          repositoryCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          repositoryCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );

          return repositoryCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
